/*
  <pack-composer> — composition d'un pack de N puffs.
  Les N <select data-pack-slot> ne sont pas soumis ; la composition est agrégée dans
  les inputs cachés properties[Composition] et properties[_Détail], rattachés au formulaire produit.

  v15 : le sélecteur rapide (data-pack-quick) propose désormais une option "Mix aléatoire"
  (valeur spéciale __mix__) en plus du choix d'une saveur unique pour tout le pack.
*/
if (!customElements.get('pack-composer')) {
  customElements.define(
    'pack-composer',
    class PackComposer extends HTMLElement {
      constructor() {
        super();
        this.slots = Array.from(this.querySelectorAll('[data-pack-slot]'));
        this.quick = this.querySelector('[data-pack-quick]');
        this.fillAllBtn = this.querySelector('[data-pack-fill-all]');
        this.mixBtn = this.querySelector('[data-pack-mix]');
        this.summary = this.querySelector('[data-pack-summary]');
        this.propInput = this.querySelector('[data-pack-property]');
        this.detailInput = this.querySelector('[data-pack-detail]');

        this.slots.forEach((s) => s.addEventListener('change', () => this.update()));
        if (this.fillAllBtn) this.fillAllBtn.addEventListener('click', () => this.fillAll());
        if (this.mixBtn) this.mixBtn.addEventListener('click', () => this.mix());
        if (this.quick) {
          this.quick.addEventListener('change', () => {
            if (this.quick.value === '__mix__') {
              this.mix();
            } else if (this.quick.value) {
              this.fillAll();
            }
          });
        }

        this.update();
      }

      get flavours() {
        return Array.from(this.slots[0].options).map((o) => o.value);
      }

      fillAll() {
        const value = this.quick && this.quick.value && this.quick.value !== '__mix__' ? this.quick.value : this.slots[0].value;
        this.slots.forEach((s) => (s.value = value));
        this.update();
      }

      mix() {
        const f = this.flavours;
        this.slots.forEach((s, i) => (s.value = f[i % f.length]));
        if (this.quick) this.quick.value = '__mix__';
        this.update();
      }

      update() {
        const counts = new Map();
        this.slots.forEach((s) => counts.set(s.value, (counts.get(s.value) || 0) + 1));
        const summary = Array.from(counts.entries())
          .map(([name, n]) => `${name} ×${n}`)
          .join(', ');
        const detail = this.slots.map((s, i) => `${i + 1}: ${s.value}`).join(' | ');
        if (this.propInput) this.propInput.value = summary;
        if (this.detailInput) this.detailInput.value = detail;
        if (this.summary) this.summary.textContent = summary;
      }
    }
  );
}
